export const initialise = () => {
    window.addEventListener('load', () => {
        const widget = document.querySelector('.attrax-job-alert-signup-widget')
        if (!widget) return

        const step2 = document.querySelector<HTMLElement>('.step2')
        if (step2) {
            widget.scrollIntoView({behavior: 'auto'})
        }
        
        const alert = widget.querySelector<HTMLElement>('.alert-success')
        alert?.scrollIntoView({behavior: 'auto'})
    })
}